import { useEffect, useState } from 'react';

const navItems = [
  { id: 'entry', label: '入口总览' },
  { id: 'latest', label: '最新地址' },
  { id: 'directory', label: '网址大全' },
  { id: 'access', label: '访问指南' },
  { id: 'verify', label: '辨别真伪' },
  { id: 'permanent', label: '永久入口' },
  { id: 'faq', label: '常见问题' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const linkColor = scrolled ? 'text-foreground-700 hover:text-primary-700 hover:bg-primary-50' : 'text-background-100 hover:text-background-50 hover:bg-background-50/10';
  const brandColor = scrolled ? 'text-foreground-950' : 'text-background-50';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between w-full h-16 md:h-[68px] px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className={`w-9 h-9 flex items-center justify-center rounded-lg ${scrolled ? 'bg-primary-500 text-background-50' : 'bg-background-50/15 text-background-50'}`}>
            <i className="ri-movie-2-line text-xl"></i>
          </span>
          <span className={`font-heading text-lg font-semibold tracking-wide ${brandColor}`}>星辰影院</span>
        </a>

        <nav className="hidden lg:flex items-center gap-0.5">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer ${linkColor}`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#entry"
            className={`hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
              scrolled ? 'bg-primary-500 text-background-50 hover:bg-primary-600' : 'bg-background-50 text-foreground-900 hover:bg-background-100'
            }`}
          >
            <i className="ri-compass-3-line"></i>
            进入入口总览
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md border transition-colors cursor-pointer ${
              scrolled ? 'border-background-300 text-foreground-800' : 'border-background-50/30 text-background-50'
            }`}
          >
            <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-b border-background-200/70 px-4 pb-4">
          <nav className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 rounded-md text-sm font-medium text-foreground-800 bg-background-100 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}